<template>
  <div class="car" v-bind:class="{ 'confirmation-car': !notConfirmation }">
    <inclusionsModal
      :currentIndex="currentIndex"
      :inclusionsModal.sync="inclusionsModal"
      :rateType="rateType"
      :standardExcludedProps="standardExcludedProps"
      :superExcludedProps="superExcludedProps"
      :onewayFeePrompt="onewayFeePrompt"
      @update:inclusionsModal="inclusionsModal = $event"
      :listingDetails="listingDetails"
    />
    <rentalConditionsModal
      :currentIndex="currentIndex"
      :rentalConditionsModal.sync="rentalConditionsModal"
      @update:rentalConditionsModal="rentalConditionsModal = $event"
      :rateType="rateType"
    />

    <b-modal
      :active.sync="extrasModal"
      scroll="keep"
      key="extrasModal"
      :can-cancel="['escape', 'x', 'outside']"
    >
      <div class="card">
        <div class="card-content">
          <h2 class="price-heading">Optional extras and border crossings</h2>
          <div class="mt-24">
            <div class="extra-options-container">
              <b-field>
                <b-checkbox v-model="currentExtras" native-value="driver" disabled
                  >Additional driver: FREE!</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="additionalDriver"
                  >2nd additional driver: R{{ this.fees.additionalDriverFee }}</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="tyreAndWindscreenWaiver"
                  :disabled="isSuper === '2'"
                  >Windscreen and tyre waiver:
                  {{
                    isSuper === "2"
                      ? "FREE!"
                      : `R${this.fees.tyreAndWindscreenWaiver} per day`
                  }}</b-checkbox
                >
              </b-field>

              <b-field class="baby-col">
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="excessWaiver"
                  >Excess Waiver: R{{ excessWaiverPrice }} per day</b-checkbox
                >
                <div
                  v-if="currentExtras.includes('excessWaiver')"
                  class="custom-number-input"
                >
                  <div class="baby-col">
                    <span class="tiny-label"
                      >Excess waiver, cover excess applicable, in event of accident/theft
                      + claims handling fee</span
                    >
                  </div>
                </div>
              </b-field>

              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="bikeRack"
                  >Bike rack: R{{ this.fees.bikeRack }} per day</b-checkbox
                >
              </b-field>
              <b-field class="baby-col">
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="babySeat"
                  >Baby seat (0 - 5 months): R{{ this.fees.babySeat }} per
                  seat</b-checkbox
                >
                <div
                  v-if="currentExtras.includes('babySeat')"
                  class="custom-number-input"
                >
                  <div class="baby-col">
                    <span class="tiny-label">Number of baby seats</span>
                    <span>{{ numberOfBabySeats }}</span>
                  </div>
                  <div class="flex-row number-buttons">
                    <img
                      v-on:input="updateExtrasPrice()"
                      @click="numberOfBabySeats--"
                      src="@/assets/images/icons/interface-minus-large.png"
                      alt="minus icon"
                    />
                    <img
                      v-on:input="updateExtrasPrice()"
                      @click="numberOfBabySeats++"
                      src="@/assets/images/icons/interface-plus-large.png"
                      alt="plus icon"
                    />
                  </div>
                </div>
              </b-field>
              <b-field class="baby-col">
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="childSeat"
                  >Child seat (6 months - 3 years): R{{ this.fees.childSeat }} per
                  seat</b-checkbox
                >

                <div
                  v-if="currentExtras.includes('childSeat')"
                  class="custom-number-input"
                >
                  <div class="baby-col">
                    <span class="tiny-label">Number of child seats</span>
                    <span>{{ numberOfChildSeats }}</span>
                  </div>
                  <div class="flex-row number-buttons">
                    <img
                      v-on:input="updateExtrasPrice()"
                      @click="numberOfChildSeats--"
                      src="@/assets/images/icons/interface-minus-large.png"
                      alt="minus icon"
                    />
                    <img
                      v-on:input="updateExtrasPrice()"
                      @click="numberOfChildSeats++"
                      src="@/assets/images/icons/interface-plus-large.png"
                      alt="plus icon"
                    />
                  </div>
                </div>
              </b-field>
              <b-field class="baby-col">
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="boosterSeat"
                  >Booster seat (3 years - 6 years): R{{ this.fees.boosterSeat }} per
                  seat</b-checkbox
                >
                <div
                  v-if="currentExtras.includes('boosterSeat')"
                  class="custom-number-input"
                >
                  <div class="baby-col">
                    <span class="tiny-label">Number of booster seats</span>
                    <span>{{ numberOfBoosterSeats }}</span>
                  </div>
                  <div class="flex-row number-buttons">
                    <img
                      v-on:input="updateExtrasPrice()"
                      @click="numberOfBoosterSeats--"
                      src="@/assets/images/icons/interface-minus-large.png"
                      alt="minus icon"
                    />
                    <img
                      v-on:input="updateExtrasPrice()"
                      @click="numberOfBoosterSeats++"
                      src="@/assets/images/icons/interface-plus-large.png"
                      alt="plus icon"
                    />
                  </div>
                </div>
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="gps"
                  >GPS rental: R{{ this.fees.gpsRental }} per day</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="botswanaBorder"
                  >Cross Botswana border: R{{ this.fees.crossBorderFee }}</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="lesothoBorder"
                  >Cross Lesotho border: R{{ this.fees.crossBorderFee }}</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="eswatiniBorder"
                  >Cross Eswatini border: R{{ this.fees.crossBorderFee }}</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="namibiaBorder"
                  >Cross Namibia border: R{{ this.fees.crossBorderFee }}</b-checkbox
                >
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="currentExtras"
                  v-on:input="updateExtrasPrice()"
                  native-value="mozambiqueBorder"
                  style="align-items: flex-start;"
                  >Cross Mozambique border: R{{ this.fees.mozambiqueFee }}<br>
                  <span style="font-size: 0.85em;">
                    (Subject to supplier approval. Conditions apply.)
                  </span>
                </b-checkbox>
              </b-field>
            </div>
          </div>
          <div class="mt-24" type="is-warning" style="color: rgba(91, 98, 111, 1)">
            <b>Note:</b> All optional extras selected, along with the rental deposit of R2
            000, will be debited at the time of vehicle collection. All cross border
            charges along with the rental days' cost, will be debited at time of your
            booking. Please ensure you have read and understood all rental conditions.
          </div>
          <div class="modal-divider"></div>
          <div class="modal-close-container">
            <div @click="selectCar()" class="close-button">Continue</div>
          </div>
        </div>
      </div>
    </b-modal>

    <section class="car__main">
      <div class="car__image">
        <img
          :src="fetchImagePath(listingDetails.group)"
          :alt="`car image ${listingDetails.group}`"
        />
        <h1 class="car-name">{{ listingDetails.name }}</h1>
        <span>(or similar)</span>
        <span
          v-if="listingDetails.group == 'O' || listingDetails.group == 'Y'"
          style="color: red; margin-top: 8px"
          >C1 & PDP licence required</span
        >
      </div>

      <div class="car__content">
        <div class="car__details">
          <div class="flex-row align-between">
            <span class="discount-notice">R{{ price }} per day</span>
            <span class="car__price">
              Total price for {{ searchParameters.totalDays }} days
              <b>
                &nbsp; R{{ price * searchParameters.totalDays + adminFee + onewayFee }}</b
              >
            </span>
          </div>
          <hr class="details-divider" />
        </div>
        <div class="gap-16-col" v-if="currentIndex === expandedIndex || !isNarrowScreen">
          <h2 class="car__heading">Vehicle features</h2>
          <div class="car__features">
            <div class="details-column">
              <div class="details-item">
                <div class="point"></div>
                <span>{{ listingDetails.seats }} seats</span>
              </div>
              <div class="details-item">
                <div class="point"></div>
                <span>{{ listingDetails.doors }} doors</span>
              </div>
              <div class="details-item">
                <div class="point"></div>
                <span>{{ automatic }}</span>
              </div>
            </div>
            <div class="car__included-list">
              <div
                class="included-item"
                v-for="item of booleanProperties.slice(0, 3)"
                :key="item.index"
              >
                <div class="item-wrapper">
                  <img src="@/assets/images/icons/ticks-large.png" alt="tick icon" />
                  &nbsp;
                  {{
                    item.toLowerCase().charAt(0).toUpperCase() +
                    item.toLowerCase().slice(1)
                  }}
                </div>
              </div>
            </div>
            <div class="car__included-list" v-if="booleanProperties.length > 3">
              <div
                class="included-item"
                v-for="item of booleanProperties.slice(3)"
                :key="item.index"
              >
                <div class="item-wrapper">
                  <img src="@/assets/images/icons/ticks-large.png" alt="tick icon" />
                  &nbsp;
                  {{
                    item.toLowerCase().charAt(0).toUpperCase() +
                    item.toLowerCase().slice(1)
                  }}
                </div>
              </div>
            </div>
          </div>
          <h2 class="car__heading">Rate type</h2>
          <div>
            <div class="radio-container">
              <b-field class="radio-wrapper">
                <b-radio v-model="isSuper" native-value="0" class="radio-button">
                  <span>Standard </span>
                </b-radio>
              </b-field>
              <b-field class="radio-wrapper">
                <b-radio v-model="isSuper" native-value="1" class="radio-button">
                  <span>Super </span>
                </b-radio>
              </b-field>
              <!-- listingDetails.group !== 'G1' -->
              <b-field
                class="radio-wrapper"
                v-if="
                  expressLaneValid &&
                    listingDetails.group !== 'M' &&
                    listingDetails.group !== 'Y' &&
                    listingDetails.group !== 'O' &&
                    !isBakkie
                "
              >
                <b-radio v-model="isSuper" native-value="2" class="radio-button">
                  <span>Express Lane </span>
                </b-radio>
              </b-field>
            </div>
            <div class="rate-prompt">
              {{ ratePrompt }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="book-bar" :class="isHidden">
      <div class="flex-row" v-if="currentIndex === expandedIndex || !isNarrowScreen">
        <div @click="toggleInclusionsModal" class="included-excluded">
          Included/Excluded
        </div>
        <a class="rental-conditions" @click="toggleRentalConditionsModal"
          >Rental conditions</a
        >
      </div>
      <div class="car__booking desktop-only" v-if="notConfirmation">
        <b-button class="custom-button" type="is-primary" @click="extrasModal = true"
          >Request now</b-button
        >
      </div>
    </section>

    <section class="car__booking mobile-only" v-if="notConfirmation">
      <b-button class="custom-button" @click="toggleView">
        view {{ currentIndex === expandedIndex ? "less" : "more" }}
      </b-button>
      <b-button class="custom-button" type="is-primary" @click="extrasModal = true"
        >Request now</b-button
      >
    </section>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import inclusionsModal from "@/components/inclusionsModal.vue";
import rentalConditionsModal from "@/components/rentalConditionsModal.vue";
import { FeesData } from "@/services/Fees.js";
import { Cars } from "@/services/Car.service.js";

export default {
  name: "car",
  props: {
    listingDetails: Object,
    currentIndex: Number,
    expandedIndex: Number,
  },
  data() {
    const rateData = [
      {
        rateType: "Standard",
        mileage: "200km daily",
        dailyCharge: `R${this.listingDetails.defaultDailyCharge}`,
      },
      {
        rateType: "Super",
        mileage: "unlimited",
        dailyCharge: `R${this.listingDetails.superDailyCharge}`,
      },
      {
        rateType: "Express Lane",
        mileage: "unlimited",
        dailyCharge: `R${this.listingDetails.expressDailyCharge}`,
      },
    ];
    return {
      rateData,
      isSuper: "0",
      inclusionsModal: { key: null, value: null },
      rentalConditionsModal: { key: null, value: null },
      conditionsModal: false,
      extrasModal: false,
      currentExtrasPrice: 0,
      currentExtras: ["driver"],
      numberOfBabySeats: 1,
      numberOfChildSeats: 1,
      numberOfBoosterSeats: 1,
      fullRateType: rateData[0],
      rateColumns: [
        {
          field: "rateType",
          label: "Rate type",
        },
        {
          field: "mileage",
          label: "Mileage",
        },
        {
          field: "dailyCharge",
          label: "Daily charge",
        },
      ],
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState([
      "searchParameters",
      "currentRateType",
      "oneway",
      "expressLaneValid",
      "selectedCar",
      "lastFilterOptions",
      "isExtrasModalOpenOnMobile"
    ]),
    isBakkie() {
      return ["H", "J", "I", "N1"].includes(
        this.listingDetails.group
      );
    },
    rateType() {
      return this.fullRateType.rateType;
    },
    ratePrompt() {
      let prompt =
        "200km per day and excess of R" + this.listingDetails.excess.standard;
      if (this.isSuper === "1") {
        prompt = "Unlimited mileage and excess of R" + this.listingDetails.excess.super;
      } else if (this.isSuper === "2") {
        prompt =
          "No paperwork at pick up. Unlimited mileage, tyre and windscreen cover and excess of R" +
          this.listingDetails.excess.expressLane +
          "+ (Virtual cards not accepted for payment.)";
      }
      return prompt;
    },
    fees() {
      return FeesData;
    },
    adminFee() {
      return this.rateType === "Standard" ? this.fees.adminFee : 0;
    },
    seasonFare() {
      let pickupTime = this.searchParameters.pickupTime;
      let dropoffTime = this.searchParameters.dropoffTime;

      let seasonStart = moment(this.fees.peakSeasonStartDate, "MM-DD-YYYY");
      let seasonEnd = moment(this.fees.peakSeasonEndDate, "MM-DD-YYYY");

      // console.log(pickupTime.isBetween(seasonStart, seasonEnd, "day", "[]"));
      // console.log(seasonStart);

      return (
        pickupTime.isBetween(seasonStart, seasonEnd, "day", "[]") ||
        dropoffTime.isBetween(seasonStart, seasonEnd, "day", "[]")
      );
    },
    onewayFee() {
      let fee = this.fees.oneWayDropOffFee;
      if (this.seasonFare) {
        fee = this.fees.peakSeasonOnewayFee;
      }
      const bakkies = ["N1", "H", "J"];
      if (bakkies.includes(this.listingDetails.group)) {
        fee = this.fees.oneWayDropOffFeeBakkies;
      }
      return this.oneway ? fee : 0;
    },
    onewayFeePrompt() {
      let fee = this.fees.oneWayDropOffFee;
      if (this.seasonFare) {
        fee = this.fees.peakSeasonOnewayFee;
      }
      const bakkies = ["N1", "H", "J"];
      if (bakkies.includes(this.listingDetails.group)) {
        fee = this.fees.oneWayDropOffFeeBakkies;
      }
      return fee.toString();
    },
    booleanProperties() {
      let result = [];
      for (const key of Object.keys(this.listingDetails.details)) {
        if (this.displayItemCheck(key)) {
          result.push(
            key
              // insert a space between lower & upper
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              // space before last upper in a sequence followed by lower
              .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")
              // uppercase the first character
              .replace(/^./, function (str) {
                return str.toUpperCase();
              })
          );
        }
      }
      return result;
    },
    price() {
      if (this.rateType === "Standard") {
        return this.listingDetails.defaultDailyCharge;
      } else if (this.rateType === "Super") {
        return this.listingDetails.superDailyCharge;
      } else {
        return this.listingDetails.expressDailyCharge;
      }
    },
    automatic() {
      return this.listingDetails.automatic ? "Automatic" : "Manual";
    },
    notConfirmation() {
      if (this.$route.path == "/confirmation") {
        return false;
      } else {
        return true;
      }
    },
    standardExcludedProps() {
      return {
        mileagePrice: this.listingDetails.mileagePrice,
        excessAmount: this.getExcessAmount(this.listingDetails.group, this.isSuper),
      };
    },
    superExcludedProps() {
      return {
        excessAmount: this.getExcessAmount(this.listingDetails.group, this.isSuper),
      };
    },
    fuelDeposit() {
      if (
        this.listingDetails.group === "Z" ||
        this.listingDetails.group === "K" ||
        this.listingDetails.group === "KM" ||
        this.listingDetails.group === "L" ||
        this.listingDetails.group === "N" ||
        this.listingDetails.group === "M" ||
        this.listingDetails.group === "G1" ||
        this.listingDetails.group === "G2" ||
        this.listingDetails.group === "TF"
      ) {
        return this.fees.fuelDepositSUV;
      }
      return this.fees.fuelDepositRegular;
    },
    expressExcluded() {
      return [
        `Excess payable of R${this.getExcessAmount(
          this.listingDetails.group,
          this.isSuper
        )} per rental agreement per claim due to accident or theft. No hold is placed on your Investec Visa card. Double excess is applicable where no other vehicle or third party involved in the accident`,
        "Claims administration fee: In the event of damages a claims handling fee of R900 will be charged, and debited within fifteen working days' after the car is returned",
        `A second additional driver: An additional charge of R${this.fees.additionalDriverFee} is applicable`,
        `Young driver surcharge(18-20 years old): An additional charge of R${this.fees.youngDriverSurcharge}/day is applicable`,
        `Fuel: A deposit of R${this.fuelDeposit} is taken by the rental agency when you collect the car and sign the rental conditions. This deposit less any charges payable to the rental agency is refundable within 5-8 working days'`,
        `Refuel: Actual charge + R${this.fees.refuelFeee} service fee`,
        `E-tolling fees: Debited within eight working days' after the car is returned. A ${this.fees.eTollAdminFee} e-toll admin fee will be added to the e-toll fees`,
        `Fines and fine handling fees: Please note that fines can take up to 12 months to be redirected to you, in which you will be responsible for full settlement of:`,
        `Baby/Child/Booster seat: R${this.fees.babySeat} per rental`,
        `Traffic fine administration fee (charged per fine) of R${this.fees.trafficFineAdminFee} is charged in addition to the actual fine amount, in order to cover the cost of redirecting the fine to you`,
        "Towing costs and storage charges as well as charges for roadside assistance (unless there was mechanical breakdown). These fees are charged in addition to the liability amount / damage amount and are dependent on the rental agency",
        `Additional charges such as bike rack/s, GPS, baby/child seat/s will be subject to a liability of R${this.fees.extrasDamageLiabilityFee} in the event of loss or damage`,
        `Tyre and windscreen waivers: tyre and windscreen waivers are optional and offered at R${this.fees.tyreAndWindscreenWaiver} per waiver, per day`,
        `One way drop off fee is charged when a vehicle is collected from one location and returned to a different location. To be quoted at the time of booking`,
        `Cross-border authorisation fees of R${this.fees.crossBorderFee} apply for Lesotho, Botswana, Namibia and Eswatini`,
        `Cross Mozambique border authorisation fee of R${this.fees.mozambiqueFee} available on request only`,
        `Assessment fee in the event of an accident / damage to the hire car is charged at R${this.fees.damageAssessmentFee} per claim`,
        `Valet fee, dependent on the supplier and capped at R${this.fees.valetFee}`,
        `Delivery and collection fee during office hours (between 09h00 and 16h00 weekdays) outside a 20km radius a fee of R${this.fees.deliveryAndCollectionIn20km} and R${this.fees.deliveryAndCollectionOutside20km} per km thereafter applies. Afterhours (before 09h00 and after 16h00 during the week, public holiday’s and weekends) a fee of R${this.fees.deliveryAndCollectionIn20kmAfterhours} in a 20km radius and R${this.fees.deliveryAndCollectionOutside20kmAfterhours} per km thereafter`,
        "Driving on gravel roads is not recommended. Should any undercarriage damage occur while driving on a gravel road, the excess will not be applicable and the renter will be liable for the full cost of repair. Should any incident occur while driving on a gravel road as a result of negligence or breach of contract, the renter will liable for the full replacement cost of the vehicle. Any accident occurring on a gravel road will carry a double excess liability but excludes undercarriage damage which will be billed in full",
        "Water damage is excluded from the excess liability. The renter will be liable for full or replacement cost as a result of water damage",
        `Overdue penalty: R${this.fees.overduePenalty} per rental. This is only applicable where there has been no prior arrangements made for rental extension ahead of rental expiry date and time`,
        `No show penalty: R${this.fees.noShowPenalty} per rental. This is only applicable where there has been no prior arrangements made to cancel the booking ahead of the rental date and time.`,
      ];
    },
    // "View more" computed properties
    isNarrowScreen() {
      return this.windowWidth <= 1120;
    },
    // Dynamic class binding to hide elements on mobile collapsed "View More"
    isHidden() {
      return {
        "is-hidden": this.currentIndex !== this.expandedIndex && this.isNarrowScreen,
      };
    },
    // Calculate excess waiver price
    excessWaiverPrice() {
      const carGroupMap = {
        A: "120",
        B: "120",
        B1: "120",
        C2: "120",
        D: "120",
        E: "168",
        Z: "168",
        K: "168",
        KM: "168",
        L: "180",
        N: "180",
        G: "216",
        I: "168",
        Q: "384",
        N1: "420",
        N2: "420",
        TF: "240",
        H: "144",
        J: "144",
        O: "384",
        M: "216",
        G1: "240",
        G2: "240",
        Y: "384",
      };

      return carGroupMap[this.listingDetails.group];
    },
  },
  mounted() {
    if (this.lastFilterOptions) {
      this.isSuper = this.lastFilterOptions.isSuper;
    }
    if (this.listingDetails.group == this.selectedCar.group) {
      // console.log("selected car group", this.selectedCar.group);
      switch (this.selectedCar.rateType) {
        case "Standard":
          this.isSuper = "0";
          break;
        case "Super":
          this.isSuper = "1";
          break;
        case "Express Lane":
          this.isSuper = "2";
          break;
        default:
          this.isSuper = "0";
      }
    }
  },
  watch: {
    currentRateType: {
      handler(newVal) {
        // console.log(newVal);
        // this.fullRateType = this.rateData[newVal];
        this.isSuper = newVal;
      },
    },
    numberOfBabySeats: {
      handler(newVal) {
        if (newVal < 0) {
          this.numberOfBabySeats = 0;
        } else if (newVal == 0) {
          this.currentExtras = this.currentExtras.filter((extra) => extra !== "babySeat");
        }
        this.updateExtrasPrice("babySeat");
      },
    },
    numberOfChildSeats: {
      handler(newVal) {
        if (newVal < 0) {
          this.numberOfChildSeats = 0;
        } else if (newVal == 0) {
          this.currentExtras = this.currentExtras.filter(
            (extra) => extra !== "childSeat"
          );
        }
        this.updateExtrasPrice("childSeat");
      },
    },
    numberOfBoosterSeats: {
      handler(newVal) {
        if (newVal < 0) {
          this.numberOfBoosterSeats = 0;
        } else if (newVal == 0) {
          this.currentExtras = this.currentExtras.filter(
            (extra) => extra !== "boosterSeat"
          );
        }
        this.updateExtrasPrice("boosterSeat");
      },
    },
    isSuper() {
      this.fullRateType = this.rateData[this.isSuper];
      if (this.isSuper === "2" && !this.currentExtras.includes("tyreAndWindscreenWaiver")) {
        this.currentExtras.push("tyreAndWindscreenWaiver");
      } else if (this.isSuper !== "2") {
        this.currentExtras = this.currentExtras.filter(
          extra => extra !== "tyreAndWindscreenWaiver"
        );
      }
      
      this.updateExtrasPrice();
    },

    extrasModal: {
      handler(newVal) {
        this.$emit(newVal ? "modalOpened" : "modalClosed");
        this.updateExtrasModal();
      },
      deep: true,
    },
  },
  // Lifecyle hooks used for 'View More' device width conditions
  created() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    //does not display the filter bar on mobile when the extras modal pops up
    updateExtrasModal() {
      this.$store.commit('updateIsExtrasModalOpenOnMobile', this.extrasModal);
    },
    getExcessAmount(group, type) {
      const car = Cars.find(item => item.group === group);
      const types = ['standard', 'super', 'expressLane'];
      const selectedType = types[type] || 'standard';

      return car ? car.excess[selectedType] : "6 000";
    },
    selectCar() {
      this.$store.commit("setSelectedCar", {
        ...this.listingDetails,
        price:
          this.price * this.searchParameters.totalDays +
          this.currentExtrasPrice +
          this.adminFee +
          this.onewayFee,
        totalPrice: this.price,
        totalExtrasPrice: this.currentExtrasPrice,
        totalExtras: this.currentExtras,
        totalDays: this.searchParameters.totalDays,
        rateType: this.rateType,
        adminFee: this.adminFee,
        onewayFee: this.onewayFee,
        numberOfBabySeats: this.numberOfBabySeats,
        numberOfChildSeats: this.numberOfChildSeats,
        numberOfBoosterSeats: this.numberOfBoosterSeats,
      });
      this.$router.push("/details");
    },
    updateExtrasPrice() {
      let temp = 0;
      for (let extra of this.currentExtras) {
        switch (extra) {
          case "gps":
            temp += this.fees.gpsRental * this.searchParameters.totalDays;
            break;
          case "additionalDriver":
            temp += this.fees.additionalDriverFee;
            break;
          case "bikeRack":
            temp += this.fees.bikeRack * this.searchParameters.totalDays;
            break;
          case "babySeat":
            temp += this.fees.babySeat * this.numberOfBabySeats;
            break;
          case "childSeat":
            temp += this.fees.childSeat * this.numberOfChildSeats;
            break;
          case "boosterSeat":
            temp += this.fees.boosterSeat * this.numberOfBoosterSeats;
            break;
          case "tyreAndWindscreenWaiver":
            temp +=
              this.isSuper == "2"
                ? 0
                : this.fees.tyreAndWindscreenWaiver * this.searchParameters.totalDays;
            break;
          case "excessWaiver":
            temp += this.excessWaiverPrice * this.searchParameters.totalDays;
            break;
          case "botswanaBorder":
            temp += this.fees.crossBorderFee;
            break;
          case "eswatiniBorder":
            temp += this.fees.crossBorderFee;
            break;
          case "namibiaBorder":
            temp += this.fees.crossBorderFee;
            break;
          case "lesothoBorder":
            temp += this.fees.crossBorderFee;
            break;
          case "mozambiqueBorder":
            temp += this.fees.mozambiqueFee;
            break;
          default:
            break;
        }
      }
      this.currentExtrasPrice = temp;
    },
    fetchImagePath(group) {
      if (group == "I") {
        return require(`@/assets/images/cars/${group}.jpg`);
      } else {
        return require(`@/assets/images/cars/${group}.png`);
      }
    },
    displayItemCheck(key) {
      return this.listingDetails.details[key] === true;
    },
    // Helpers for "View more" functionality
    toggleView() {
      this.$emit("toggleView", this.currentIndex);
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    toggleInclusionsModal() {
      if (this.inclusionsModal.key === this.currentIndex && this.inclusionsModal.value) {
        this.inclusionsModal = { key: null, value: false };
      } else {
        this.inclusionsModal = { key: this.currentIndex, value: true };
      }
    },
    toggleRentalConditionsModal() {
      if (
        this.rentalConditionsModal.key === this.currentIndex &&
        this.rentalConditionsModal.value
      ) {
        this.rentalConditionsModal = { key: null, value: false };
      } else {
        this.rentalConditionsModal = { key: this.currentIndex, value: true };
      }
    },
  },
  components: {
    inclusionsModal,
    rentalConditionsModal,
  },
};
</script>

<style>
.modal-content::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.modal-content {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.item-wrapper {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.modal-content::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.modal-content {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.b-radio.radio {
  display: -webkit-inline-box;
}

.point {
  height: 16px;
  width: 16px;
  background: #30384a;
  border-radius: 100%;
  border: 1.5px solid #306e33;
}

.discount-notice {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500 !important;
  font-size: 24px !important;
  line-height: 28px !important;
  /* identical to box height, or 156% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em !important;

  /* color/sys/light/text/info */

  color: #1463aa !important;

  img {
    height: 0.9rem;
    margin-right: 0.5em;
  }
}

hr {
  margin: 1.2rem 0;
}

.green {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */

  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.model-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */

  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
  margin-bottom: 24px;
}

.text-left {
  text-align: left;
}

.flex-row {
  display: flex;
  align-items: center;
}

.details-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.details-item {
  display: flex;
  white-space: nowrap;
  gap: 16px;
}

.flex-col {
  display: flex;
  flex-direction: column;
  padding-left: 0.4em;
}

.baby-col {
  display: flex;
  flex-direction: column;
}

.car {
  max-width: 800px;
  background: #ffffff;
  padding: 8px;
  box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05), 0px 2px 8px -2px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.confirmation-car {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
}

.rental-conditions {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-left: 25px;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: #30384a;
}

.included-excluded {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: #30384a;
  cursor: pointer;
}

.car__heading {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #30384a !important;
}

.rate-prompt {
  color: #be7d2d;
  font-size: 12px;
  font-weight: 500;
}

.car__image {
  max-width: 100%;
  width: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  img {
    max-width: 80%;
    width: fit-content;
    margin-bottom: 16px;
  }
  .car-name {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: center;
    letter-spacing: 0.01em;

    /* color/sys/light/text/lvl-1 */

    color: #30384a;
  }
  span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: center;
    letter-spacing: 0.01em;

    /* color/sys/light/text/lvl-3 */

    color: #5b626f;
  }
}

.dropdown-content {
  min-width: max-content;
}

.car__details {
  grid-area: details;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  i {
    color: darken($primary-dark, 60%);
    width: 2em;
  }
  .details-divider {
    border-bottom: 0.4px solid rgba(236, 236, 233, 1);
    height: 2px;
    width: 100%;
    margin: 0.75em 0;
  }
  .green {
    color: green;
  }
  .red {
    color: red;
  }
  .car__price {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #5b626f;
    span {
      text-decoration: none !important;
      text-align: left;
    }
    .line-through {
      text-decoration: line-through;
    }
  }
}

.font-700 {
  font-weight: 700 !important;
}

.flex-row {
  display: flex;
  align-items: center;
}

.align-between {
  justify-content: space-between;
  width: 100%;
}

.car__included-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  img {
    max-width: 100%;
  }
  .details-divider {
    border-bottom: 0.4px dashed darken($primary-dark, 30%);
    height: 0.4px;
    width: 100%;
    margin: 0.75em 0;
  }
  .details-item {
    display: flex;
    white-space: nowrap;
    text-align: left;
  }
  h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    /* identical to box height, or 156% */

    display: flex;
    align-items: center;
    letter-spacing: 0.01em;

    /* color/sys/light/text/lvl-1 */

    color: #30384a;
    padding-bottom: 0.75em;
  }
  .included-item {
    display: flex;
    gap: 16px;
    font-size: 0.8em;
    text-align: left;
    width: 100%;
    color: darken($primary-dark, 50%);
    i {
      color: $success;
    }
  }
}

.car__book {
  grid-area: included;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  img {
    max-width: 100%;
  }
  h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    /* identical to box height, or 156% */

    display: flex;
    align-items: center;
    letter-spacing: 0.01em;

    /* color/sys/light/text/lvl-1 */

    color: #30384a;
    padding-bottom: 0.75em;
  }
}

.car__booking {
  grid-area: booking;
  width: 100%;
  margin-left: auto;
  .booking-button {
    font-size: 1em;
    margin: $standard-padding 0;
    padding: 0.25em 0.5em;
    background: $secondary-color;
    color: white;
    border: 1px solid black;
    border-radius: 6px;
    cursor: pointer;
  }
}

.book-bar {
  grid-area: book;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.margin-right {
  margin-right: 1em;
  font-size: 1.2rem;
  font-weight: 600;
}

.standard-margin-bottom {
  margin-bottom: 0.75em;
}

.trip-review {
  background: $cararra;
  margin: 0;
  overflow-y: scroll;
  min-height: 100vh;
}

.custom-tabs {
  max-width: 800px;
  margin: auto;
  color: $brandBlue !important;
  margin-bottom: 0 !important;
}

.flight-info {
  display: flex;
  flex-direction: column;
}

.progress-buttons {
  display: flex;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 0.75em;
  justify-content: space-around;
  align-items: center;
  section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: 120px;
    padding-right: 120px;
  }
}

.back-button {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  border-radius: 0 !important;
  padding: 22px 85px !important;
  color: white;
  font-size: 1.2rem !important;
  cursor: pointer;
}

.my-button {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  border-radius: 0 !important;
  padding: 22px 85px !important;
}

.back-button {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  border-radius: 0 !important;
  padding: 22px 85px !important;
  color: white;
  font-size: 1.2rem !important;
  cursor: pointer;
}

.back {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 140%;
  color: white;
}

.extra-options-wrapper {
  margin-left: 16px;
}

.extra-options-container {
  display: flex;
  flex-wrap: wrap;
}
.extra-options-container > * {
  flex: 50%;
}
.radio-container {
  display: flex;
  gap: 24px;
}
// Mobile styles
@media (max-width: 1120px) {
  .car {
    padding: 16px 24px 16px 24px;
  }

  .car__main {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .car__price {
    span {
      white-space: initial;
    }
    .discount-notice {
      white-space: nowrap;
    }
  }
  .car__image {
    img {
      max-width: 234px;
      margin-top: 16px;
    }
  }
  .car__details {
    display: flex;
    align-items: center;
    .flex-row {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      .car-price {
        font-size: 12px !important;
        line-height: 18px;
        font-weight: 500;
        color: #5b626f;
      }
    }
  }

  .car__details .flex-col {
    align-items: center;
  }
  .car__details .no-center {
    align-self: flex-start; // Or whatever alignment you prefer
  }

  .car__details .flex-col span.discount-notice {
    font-size: 24px !important;
    line-height: 32px !important;
  }

  .car__details .flex-col span.car__price {
    font-size: 12px !important;
    line-height: 18px !important;
    font-weight: 500 !important;
  }

  .car__booking.mobile-only > .custom-button:first-child {
    margin-bottom: 16px;
  }
  // Used in "View More" functionality
  .is-hidden {
    display: none;
  }
  .rate-info {
    display: none;
  }
  .car__book {
    display: flex;
    flex-direction: column;

    h2 {
      width: 100%;
      text-align: center;
    }
    .radio-container {
      display: flex;
      flex-direction: row;
      & > .radio-wrapper {
        display: inline-flex;
        margin: 0;
        padding: 0;
        align-items: center;

        .radio-button {
          margin-bottom: 0 !important;
        }
      }
      .radio-wrapper:nth-of-type(2) {
        margin-left: 32px;
      }
    }
  }
  .book-bar .flex-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .included-excluded,
    .rental-conditions {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    .rental-conditions {
      margin-top: 16px;
    }
  }
  .price-modal,
  .conditions-modal {
    z-index: 999;
  }
  .control-label {
    font-size: 16px;
    line-height: 24px;
    height: auto;
  }
}

.car__features {
  display: flex;
  gap: 32px;
}

@media (max-width: 1120px) {
  .extra-options-container {
    margin-top: 15px;
  }

  .car__features {
    flex-direction: column;
    gap: 16px;
  }

  .radio-container {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .car__price {
    font-size: 12px !important;
    font-weight: 500 !important;
  }
  .extra-options-container > * {
    flex: 100%;
    margin-left: 15px;
  }

  .back-button {
    font-size: 12px !important;
    padding: 0 !important;
  }
  .my-button {
    font-size: 12px !important;
    padding: 22px 55px !important;
  }
  .car__booking {
    .button {
      width: 100%;
    }
  }
  .custom-tabs {
    margin-top: 50px;
    max-width: 90%;
  }
}

.gap-16-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 1120px) {
  .car__main {
    display: flex;
    gap: 24px;
    width: 100%;
  }

  .car__included-list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap !important;
  }

  .car__content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .car {
    padding: 32px;
    min-width: 781px;
    .car__book {
      justify-content: flex-start;
      margin: 0;
    }
    .car__details {
      margin: 0;
    }
    .car__price {
      justify-content: flex-start;
      font-family: "Inter";
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      letter-spacing: 0.01em;
      color: #5b626f;
      span {
        text-decoration: none !important;
      }
    }
    .car__included-list {
      flex-direction: column;
      i {
        color: $success;
        width: 1.5em;
      }
      h2 {
        width: fit-content;
      }
    }
    .booking-button {
      margin-bottom: 0;
    }
    .details-item {
    }
    .car__booking {
      margin-left: unset;
      width: auto;
    }
  }
}
</style>

<style lang="scss">
.custom-button {
  border-radius: 104px !important;
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.01em !important;

  /* color/sys/light/text/contrast */

  color: #ffffff;
}
.progress-buttons {
  display: flex;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  padding: 0.75em;
  background: white;
  justify-content: flex-end;
  align-items: center;
}

.fa,
.far,
.fas {
  font-family: "Font Awesome 5 Free" !important;
}

.dropdown-content {
  min-width: max-content;
}

.message-header p {
  color: white;
}

.capitalize-text {
  text-transform: capitalize;
}

.extra-options-container {
  display: flex;
  flex-wrap: wrap;
}

.extra-options-container > * {
  flex: 50%;
}

@media (max-width: 1120px) {
  .extra-options-container {
    margin-top: 15px;
  }

  .extra-options-container > * {
    flex: 100%;
    margin-left: 15px;
  }

  .media-content {
    overflow-x: hidden;
  }
  .progress-buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0;
  }
  .b-tabs {
    padding-bottom: 120px;
  }
  .column {
    .field {
      label {
        .control-label {
          white-space: unset;
        }
      }
    }
  }
}

.message-body {
  border-radius: 0;
  background: #d7d9db;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  color: #02214d;
}

ul {
  list-style: disc !important;
}

.modal .modal-content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 10px 10px -8px rgba(0, 0, 0, 0.04), 0px 6px 4px -4px rgba(0, 0, 0, 0.06),
    0px 8px 16px -4px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.model-content::-webkit-scrollbar {
  display: none;
}

.modal-background {
  background: rgba(230, 229, 225, 0.5);
  backdrop-filter: blur(20px);
}

.card-content {
  padding: 40px !important;
}

.price-heading {
  font-family: "Libre Caslon Text";
  font-style: normal;
  font-weight: 400 !important;
  font-size: 40px !important;
  line-height: 48px !important;
  /* identical to box height, or 120% */

  display: flex;
  align-items: center;
  letter-spacing: -0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a !important;
}

.modal-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700 !important;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-3 */

  color: #5b626f !important;
}

ul {
  margin-left: 24px !important;
}

ul li {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-3 */

  color: #5b626f !important;
}

.modal-close {
  background: rgba(10, 10, 10, 0.3) !important;
}

.modal-close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 16px;
  padding: 8px 16px;

  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
}

.modal-divider {
  height: 2px;
  background: #ecece9;
  width: 100%;
  margin-top: 24px;
}

.modal-close-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
}

.close-button {
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  height: 40px;

  /* color/sys/light/bg/primary/strong/default

ref: navy.900
*/
  background: #30384a;
  /* color/sys/light/outline/primary/strong/default

ref: color.ref.navy.900
*/
  border: 2px solid #30384a;
  border-radius: 20px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  text-align: right;
  letter-spacing: 0.01em;

  /* color/sys/light/text/contrast */

  color: #ffffff;
}

.conditions-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-3 */

  color: #5b626f;
}

.mt-24 {
  margin-top: 24px !important;
}

.custom-number-input {
  background: #f6f6f4;
  /* color/sys/light/outline/lvl-1

ref: color.ref.navy.900
*/
  border: 1px solid #30384a;
  border-radius: 8px;
  width: 90%;
  padding: 7px 16px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.number-buttons {
  width: 60px;
  justify-content: space-between;
  font-size: 24px;
  cursor: pointer;
  font-weight: 600;
}

.tiny-label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-3 */

  color: #5b626f;
}
</style>
